module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAOVBMVEUAAAA7iMM7iMM7iMM7iMM7iMM7iMM7iMPa6fTz+PuFtdq20ulHj8dgns5Ul8upy+V4rdb///9sptJUsHCKAAAAB3RSTlMAYL8AIM/vi50ITwAAAO5JREFUeF7t2MkKwzAMBFCvkZds7f9/bJOToFDFg3UoxvMB7zYDkrljHXXEWX/FeB8idSaGGwoLdWcJFxRJIdEbSyqxxulAzpBS/hma0ITSqzlJhNZmKa0CxBLoMMTZc4uTt+eKbBlyGMIldmSIzieotFakAA5DsFSQihy/nYpVpAIOQ4BU8dImoRgQtCbAYUiW2IEgrp1QDATisrCDQyyxA0BC7Qoh0Ps7VXDmZovJ+6CbfQ662ceom02DbvY+6Gaf1ANRwTdblgoBkFC7gwBIKEslDYhqHfTMmpDak0Xt7aP1iFJ7jWk+665ovA8/Xlu2SpC9TU8AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/devfest/23ec.png
// module id = 1330
// module chunks = 0